/*
 * VivaNutrition: live Amazon price (and in-copy product box) for affiliate products.
 *
 * Owner decision 2026-09-25: show the Amazon price on the store the same way the blog does
 * (live price, no timestamp), on the PDP, collection cards and home cards.
 *
 * Source: the vn-haf feed on the Hostinger WordPress site (Hostinger Affiliate Marketing Tools
 * data, refreshed about daily). The feed returns pricing=null once a product has gone 36h
 * without a successful refresh; then nothing is replaced and the page keeps its fallback text
 * ("See how to buy" / no price line). If the feed is unreachable, same fallback.
 *
 * Targets:
 *   [data-vn-amazon-price="ASIN"]                  price text: "£135.00 on Amazon"
 *   .vn-amazon-live[data-vn-amazon-asin="ASIN"]    in-copy box (from the PDP deck block
 *                                                  `amazon_live`): image, Amazon title, price,
 *                                                  link = data-vn-href (the product's SHOP link)
 */
(function () {
  var script = document.currentScript;
  var FEED = script && script.getAttribute('data-feed');
  if (!FEED || !window.fetch) return;
  var CACHE_KEY = 'vn-amazon-live:v1';
  var CACHE_MS = 10 * 60 * 1000;
  var known = {};

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
      Object.keys(c).forEach(function (a) { if (Date.now() - c[a].t < CACHE_MS) known[a] = c[a].p; });
    } catch (e) {}
  }
  function writeCache() {
    try {
      var c = {};
      Object.keys(known).forEach(function (a) { c[a] = { t: Date.now(), p: known[a] }; });
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(c));
    } catch (e) {}
  }

  function asinsOnPage() {
    var set = {};
    document.querySelectorAll('[data-vn-amazon-price],[data-vn-amazon-asin]').forEach(function (el) {
      var a = (el.getAttribute('data-vn-amazon-price') || el.getAttribute('data-vn-amazon-asin') || '').trim().toUpperCase();
      if (/^[A-Z0-9]{10}$/.test(a)) set[a] = true;
    });
    return Object.keys(set);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function paint() {
    document.querySelectorAll('[data-vn-amazon-price]:not([data-vn-done])').forEach(function (el) {
      var p = known[(el.getAttribute('data-vn-amazon-price') || '').toUpperCase()];
      if (!p || !p.pricing || p.stale) return;
      el.innerHTML = esc(p.pricing) + ' <small class="vn-amz-on">on Amazon</small>';
      el.hidden = false;
      el.setAttribute('data-vn-done', '1');
    });
    document.querySelectorAll('.vn-amazon-live[data-vn-amazon-asin]:not([data-vn-done])').forEach(function (el) {
      var p = known[(el.getAttribute('data-vn-amazon-asin') || '').toUpperCase()];
      if (!p) return;
      var href = el.getAttribute('data-vn-href') || '';
      var price = p.pricing && !p.stale ? '<p class="vn-amazon-live__price">' + esc(p.pricing) + ' <small class="vn-amz-on">on Amazon</small></p>' : '';
      // VCR-J-0027 (Owner 2026-10-02): the box carries our deck title (data-vn-title, else the PDP's own product
      // title), not Amazon's listing title, which can carry claims the deck removed on purpose.
      var title = el.getAttribute('data-vn-title') || (script && script.getAttribute('data-product-title')) || p.title;
      var img = p.image ? '<img class="vn-amazon-live__img" src="' + esc(p.image) + '" alt="' + esc(title) + '" loading="lazy">' : '';
      var inner = img + '<div class="vn-amazon-live__body"><p class="vn-amazon-live__title">' + esc(title) + '</p>' + price + '</div>';
      el.innerHTML = href ? '<a class="vn-amazon-live__link" href="' + esc(href) + '" target="_blank" rel="nofollow sponsored noopener">' + inner + '</a>' : inner;
      el.hidden = false;
      el.setAttribute('data-vn-done', '1');
    });
  }

  var pending = false;
  function load() {
    var need = asinsOnPage().filter(function (a) { return !(a in known); });
    paint();
    if (!need.length || pending) return;
    pending = true;
    fetch(FEED + '?asins=' + need.slice(0, 50).join(','), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        need.forEach(function (a) { known[a] = (d && d.products && d.products[a]) || null; });
        writeCache();
        paint();
      })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  readCache();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  // Cards added later (filters, infinite scroll, quick view).
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(load, 300); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
